import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const kycApi = createApi({
  reducerPath: 'kycApi',
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL + '/v2/api/' }),
  endpoints: (builder) => ({
    generateKycUrl: builder.mutation({
      query: (data) => {
        const body = new URLSearchParams({
          mode: 'okyc_v2_get_data',
          checksum: data.checksum,
          consents: typeof data.consents === 'string'
            ? data.consents
            : JSON.stringify(data.consents ?? []),
        }).toString();

        return {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
            secret: data.scrt,
            jwt_token: data.jwt_token,
          },
          body,
        };
      },
    }),

    verifyCKYCOtp: builder.mutation({
      query: (data) => {
        const body = new URLSearchParams({
          otp: data.otp,
          ckyc_id: data.ckyc_id,
        }).toString();

        return {
          method: 'POST',
          url: `${process.env.REACT_APP_API_URL}/customers/v1/journey/ckyc/partner/download?jwt_token=${data.jwt_token}&secret=${data.scrt}`,
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            secret: data.scrt,
            jwt_token: data.jwt_token,
          },
          body :{
            otp: data.otp,
            ckyc_id: data.ckyc_id,
          }
        };
      },
    }),
    resendCKYCOtp: builder.mutation({
      query: (data) => {
        return {
          method: 'POST',
          url: `${process.env.REACT_APP_API_URL}/customers/v1/journey/ckyc/partner/otp/resend?jwt_token=${data.jwt_token}&secret=${data.scrt}`,
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            secret: data.scrt,
            jwt_token: data.jwt_token,
          },
          body :{
            ckyc_id: data.ckyc_id,
          }
        };
      },
    }),
    getCkycSearch: builder.mutation({
      query: (data) => {
        return {
          method: 'GET',
          url: `${process.env.REACT_APP_API_URL}/customers/v1/journey/ckyc/partner/search?jwt_token=${data.jwt_token}&secret=${data.scrt}`,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
            secret: data.scrt,
            jwt_token: data.jwt_token,
          },
        };
      },
    }),
    redirectToDigi: builder.mutation({
      query: (data) => {
        return {
          method: 'GET',
          url: `${process.env.REACT_APP_API_URL}/customers/v1/journey/partner-digilocker-redirect?jwt_token=${data.jwt_token}&secret=${data.scrt}`,
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            secret: data.scrt,
            jwt_token: data.jwt_token,
          },
        };
      },
    }),
    triggetCkycOtp: builder.mutation({
      query: (data) => {
        return {
          method: 'GET',
          url: `${process.env.REACT_APP_API_URL}/customers/v1/journey/ckyc/partner/trigger-otp?jwt_token=${data.jwt_token}&secret=${data.scrt}`,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
            secret: data.scrt,
            jwt_token: data.jwt_token,
          },
        };
      },
    }),
  }),
});

export const { useGenerateKycUrlMutation, useVerifyCKYCOtpMutation, useResendCKYCOtpMutation, useGetCkycSearchMutation, useRedirectToDigiMutation, useTriggetCkycOtpMutation } = kycApi;
